import { createReducer } from '@reduxjs/toolkit';
import * as actions from '@/store/actions';

const initialState = null;

export default createReducer(initialState, {
	[actions.setSelectedProject.type]: (draft, { payload }) => typeof payload === 'number' ? payload : payload?.id || null,
});
